import React from "react";

const DialogIcon = ({ origin, type }) => {
  const dialogOrigin = origin || "bottomright";
  const iconType = type || "";

  return (
    <svg
      className={`dialog__icon${iconType ? "--" + iconType : ""} dialog__icon--${dialogOrigin}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 19.9"
      width="16"
      height="20"
    >
      <path
        fill="#ffffff"
        d="M12.9 17.7C10.5 14.6 5.7 7.6 1.4.8H15c-.8 2.8-3 11.4-2.1 16.9z"
      />
      <path
        fill="#e46273"
        d="M14 1.5c-.8 3-2.1 8.8-2.1 13.6-2.3-3.3-5.8-8.4-9.2-13.6H14M16 0H0s12.8 19.9 14.1 19.9c.2 0 .1-.3-.1-.9-2-6 2-19 2-19z"
      />
      <path d="M0 .8h16" stroke="#fff" strokeWidth="3" />
    </svg>
  );
};

export default DialogIcon;
